import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get("/auth/me")
      .then((res) => { if (active) setUser(res.data); })
      .catch(() => { if (active) setUser(false); })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, []);

  const login = useCallback(async (userData) => {
    setUser(userData);
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch { /* keep basic user data */ }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, checking, login, logout }), [user, checking, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
